/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  numeroCotacao: string;
  tipoDocumento: string;
}

export function useFiltrarViasPV(props: Props) {
  const postData = async () => {
    const FILTRAR_VIAS = `${backofficeEnviroment}/common/oportunidades-lead/filtrar-vias-vp/v1`;
    const { data } = await instance.post(FILTRAR_VIAS, {
      numeroCotacao: props.numeroCotacao,
      tipoDocumento: props.tipoDocumento,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {},
    onError: (error: any) => {
      toast.error(
        `Erro ao gerar vias. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
